import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "du-direct-phd-four-year-ug",
  title:
    "DU Approves Direct PhD Admission for Four-Year UG Graduates",
  description:
    "Delhi University's Academic Council has cleared direct PhD entry for students who complete the four-year UG programme under UGCF 2022. Here is who qualifies and what it means.",
  pubDate: "2026-07-25",
  updatedDate: "2026-07-26",
  authorSlug: "uday-kumar",
  category: "news",
  tags: ["DU PhD", "UGCF 2022", "FYUP", "Academic Council", "research"],
  readMinutes: 5,
  heroEyebrow: "News · Policy",
};

export function Body() {
  return (
    <>
      <p>
        Delhi University's Academic Council on July 25, 2026 approved direct admission to PhD programmes for students completing the 4-year Undergraduate Programme (FYUP) with Honours with Research under the{" "}
        <a
          href="https://www.du.ac.in/index.php?page=ugcf-2022"
          target="_blank"
          rel="noopener noreferrer"
        >
          Undergraduate Curriculum Framework (UGCF 2022)
        </a>
        . This resolution aligns DU's academic regulations with the provisions of the{" "}
        <a
          href="https://www.education.gov.in/nep-new"
          target="_blank"
          rel="noopener noreferrer"
        >
          National Education Policy (NEP) 2020
        </a>{" "}
        and the{" "}
        <a
          href="https://www.ugc.gov.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          UGC (Minimum Standards and Procedures for Award of Ph.D. Degree) Regulations 2022
        </a>
        .
      </p>

      <h2>Eligibility Requirements & Criteria</h2>
      <p>
        To qualify for direct doctoral admission without a master's degree:
      </p>
      <ul>
        <li>
          <strong>Degree Requirement:</strong> Must complete the 4-year UG degree (8 semesters) with an explicit <em>Honours with Research</em> specialization.
        </li>
        <li>
          <strong>Minimum CGPA:</strong> Must obtain a minimum cumulative grade point average (CGPA) of 7.5 on a 10-point scale (or equivalent percentage) as mandated by UGC regulations.
        </li>
        <li>
          <strong>Entrance & Interview Weightage:</strong> Candidates must clear the university entrance test (70% weightage) followed by an interview before the Departmental Research Committee (30% weightage).
        </li>
      </ul>

      <h2>Why This Matters for Current DU Students</h2>
      <p>
        The first cohort under UGCF 2022 will complete their fourth year in 2026. This academic council clearance provides operational clarity ahead of the upcoming PhD admission cycle announced on{" "}
        <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
          du.ac.in
        </a>
        .
      </p>
      <p>
        For students currently enrolled in the 3-year honours track who are deciding whether to opt into the 4th research year, this decision turns the optional fourth year into a direct fast-track for research careers in economics, natural sciences, and humanities.
      </p>

      <div className="my-8 border border-grade bg-card p-5 text-sm">
        <strong className="mono-label text-grade">Primary Regulatory Sourcing</strong>
        <p className="mt-2 text-pencil">
          Rules and CGPA thresholds are grounded in the{" "}
          <a
            href="https://www.ugc.gov.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            UGC Ph.D. Regulations 2022
          </a>{" "}
          and{" "}
          <a
            href="https://www.education.gov.in/nep-new"
            target="_blank"
            rel="noopener noreferrer"
          >
            NEP 2020 Guidelines
          </a>
          . DU Academic Council resolutions cross-referenced with press coverage in{" "}
          <a
            href="https://www.hindustantimes.com/cities/delhi-news/du-allows-4-year-ug-grads-direct-phd-admissions-101784916766660.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Hindustan Times
          </a>
          ,{" "}
          <a
            href="https://www.timesnownews.com/education/delhi-university-allows-direct-phd-admission-after-4-year-ug-programme-ac-clears-key-reforms-article-155176765"
            target="_blank"
            rel="noopener noreferrer"
          >
            Times Now
          </a>
          , and{" "}
          <a
            href="https://www.jagranjosh.com/news/delhi-university-ac-meeting-brings-direct-phd-path-new-skill-courses-and-sports-scholarship-185925"
            target="_blank"
            rel="noopener noreferrer"
          >
            Jagran Josh
          </a>
          . Official ordinance notifications will be published on{" "}
          <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
            du.ac.in
          </a>
          .
        </p>
      </div>
    </>
  );
}

